"use strict";

exports.__esModule = true;
exports.DataSourceDefinitions = void 0;
var _comments = require("./comments");
var _tickets = require("./tickets");
var _alerts = require("./alerts");
var _mtc = require("./mtc");
var _metrics = require("./metrics");
var _deviceData = require("./deviceData");
var _auditLogs = require("./auditLogs");
var _historicalPartCount = require("./historicalPartCount");
var _metricMtc = require("./metricMtc");
var _historicalPartCountShift = require("./historicalPartCountShift");
var DataSourceDefinitions = exports.DataSourceDefinitions = {
  Comments: _comments.commentsDefinition,
  Alerts: _alerts.alertsDefinition,
  Tickets: _tickets.ticketsDefinition,
  MTC: _mtc.mtcDefinition,
  Metrics: _metrics.metricsDefinition,
  deviceData: _deviceData.deviceDataDefinition,
  AuditLogs: _auditLogs.auditLogsDefinition,
  HistoricalPartCount: _historicalPartCount.historicalPartCount,
  metricMTC: _metricMtc.metricMtcDefinition,
  HistoricalPartCountShift: _historicalPartCountShift.historicalPartCountShift
};